import React from 'react';
import FilterInputField from '../../../components/TableFilter/ColumnsFilters/FilterInputField';
import FilterTreeSelect from '../../../components/TableFilter/ColumnsFilters/FilterTreeSelect/FilterTreeSelect';

export function columns({ t, lang }) {
  return [
    {
      Header: '№',
      accessor: 'rowNumber',
      maxWidth: 60,
      filterable: false
    },
    {
      Header: 'ID',
      accessor: 'serviceProviderId',
      maxWidth: 80,
      Filter: <FilterInputField name="serviceProviderId" type="number" />
    },
    {
      Header: t('monitoring_columnService'),
      accessor: 'bin',
      style: { textAlign: 'center' },
      Cell: ({ original}) => {
        return (
          <div>
            {
              lang === 'ru' ? original.serviceProviderRuName : original.serviceProviderKkName
            }
          </div>
        )
      },
      Filter: <FilterInputField name="serviceProviderName" />
    },
    {
      Header: t('monitoring_columnLocation'),
      accessor: 'location',
      Cell: ({ original: { location } }) => location[`${lang}_name`],
      maxWidth: 170,
      Filter: (
        <FilterTreeSelect
          lookupId="60"
          name="serviceProviderLocation"
          lang={lang}
          filter={item => item.ARM_gu === 'true'}
        />
      )
    },
    {
      Header: t('monitoring_columnBin'),
      accessor: 'bin',
      style: { textAlign: 'center' },
      maxWidth: 170,
      Filter: <FilterInputField name="bin" type="number" />
    },
    {
      Header: t('monitoring_columnVisitedDays'),
      accessor: 'visitedDays',
      style: { textAlign: 'center' },
      maxWidth: 170,
      filterable: false
    },
    {
      Header: t('monitoring_columnUnvisitedDaysWithReason'),
      accessor: 'unvisitedDaysWithReason',
      style: { textAlign: 'center' },
      maxWidth: 170,
      filterable: false
    },
    {
      Header: t('monitoring_columnUnvisitedDaysWithoutReason'),
      accessor: 'unvisitedDaysWithoutReason',
      style: { textAlign: 'center' },
      maxWidth: 170,
      filterable: false
    },
    {
      Header: t('monitoring_columnTotalStaff'),
      accessor: 'totalPeople',
      style: { textAlign: 'center' },
      maxWidth: 170,
      filterable: false
    }
  ];
}
